import styled from "styled-components";

export const BRAND = "#3f88a5";
export const DANGER = "#c0392b";
export const SUCCESS = "#3f8a5c";
export const GUIDE = "#7a6ba8";
export const GRID = "#e2e8f0";

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 4px 0 2px;
`;
export const Subtitle = styled.div`
  font-size: 13px;
  color: #64748b;
  margin-bottom: 16px;
`;
export const Card = styled.div`
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
`;
export const CardHeadRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
`;
export const HeadLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;
export const CardTitle = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
`;
export const HeadRight = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;
export const Legend = styled.div`
  display: flex;
  gap: 14px;
  font-size: 12px;
  color: #64748b;
  span { display: flex; align-items: center; gap: 5px; }
`;
export const Toggle = styled.div`
  display: flex;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  button {
    display: flex; align-items: center; gap: 5px;
    padding: 6px 11px; font-size: 12px; font-weight: 600; font-family: inherit;
    border: none; cursor: pointer; color: #475569;
    background: ${({ $active }) => ($active ? "transparent" : "transparent")};
  }
  button.active { background: #3f88a5; color: #fff; }
`;
export const Select = styled.select`
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  color: #475569;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  max-width: 260px;
  &:hover { border-color: #cbd5e1; }
`;
export const RateNote = styled.div`
  display: flex;
  gap: 8px;
  align-items: baseline;
  margin: 14px 20px 0;
  padding: 10px 14px;
  background: #f5f3fb;
  border: 1px solid #e4def0;
  border-radius: 8px;
  font-size: 13px;
  color: #4a4368;
  b { color: ${GUIDE}; font-size: 15px; }
`;
export const TableWrap = styled.div`
  overflow-x: auto;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  th, td { padding: 11px 16px; white-space: nowrap; text-align: right; }
  thead th {
    color: #64748b;
    font-weight: 600;
    font-size: 12px;
    border-bottom: 1px solid #e2e8f0;
  }
  thead th:first-child { text-align: left; }
  tbody td { color: #334155; border-bottom: 1px solid #f1f5f9; }
  tbody td:first-child { text-align: left; font-weight: 600; color: #1e293b; }
  tbody tr:last-child td { border-bottom: none; }
  tbody tr:hover td { background: #fafcff; }
`;
export const PaginationWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #eef2f6;
  background: #fafbfc;
`;
export const PageBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  border: 1px solid ${({ $active }) => ($active ? BRAND : "#e2e8f0")};
  border-radius: 6px;
  background: ${({ $active }) => ($active ? BRAND : "#fff")};
  color: ${({ $active }) => ($active ? "#fff" : "#475569")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: all 0.15s;
  &:hover:not(:disabled) {
    border-color: ${BRAND};
    color: ${({ $active }) => ($active ? "#fff" : BRAND)};
    background: ${({ $active }) => ($active ? BRAND : "#fafcff")};
  }
`;
export const PageInfoText = styled.span`
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
`;
export const PageNumberContainer = styled.div`
  display: flex;
  gap: 4px;
`;
export const DownloadBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 12px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 400;
  font-family: inherit;
  white-space: nowrap;
  color: #64748b;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  line-height: 1;
  transition: all 0.15s;
  svg { width: 12px; height: 12px; stroke-width: 1.5; }
  &:hover { color: #475569; border-color: #cbd5e1; }
  &:active { transform: scale(0.97); }
`;
export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  ${({ $status }) =>
    $status === "ON_TRACK"
      ? "background:#e7f3ea;color:#3f8a5c;"
      : $status === "OFF_TRACK"
        ? "background:#fbeae8;color:#d0453c;"
        : "background:#f1f5f9;color:#94a3b8;"}
`;
export const Muted = styled.div`
  padding: 40px 20px;
  text-align: center;
  font-size: 14px;
  color: #64748b;
`;
export const SubBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 20px;
  background: #fff;
  border-bottom: 1px solid #eef2f6;
`;
export const DropPanel = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 20;
  min-width: 240px;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  padding: 6px;
  label {
    display: flex; align-items: center; gap: 8px;
    padding: 7px 9px; font-size: 12.5px; color: #334155; border-radius: 6px; cursor: pointer;
    &:hover { background: #f4f7fa; }
  }
`;
export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
`;
export const SummaryCard = styled.div`
  position: relative;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 16px 15px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  &::before {
    content: "";
    position: absolute;
    ${({ $side }) => ($side === "right" ? "right: 0;" : "left: 0;")}
    top: 0; bottom: 0;
    width: 3px;
    background: ${({ $accent }) => $accent || BRAND};
  }
`;
export const SummaryTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;
export const SummaryLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  line-height: 1.3;
  min-height: 2.6em;
`;
export const SummaryIcon = styled.div`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  color: #94a3b8;
`;
export const SummaryValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
  font-variant-numeric: tabular-nums;
`;
export const SummarySub = styled.div`
  font-size: 11px;
  color: #94a3b8;
`;
export const PageShell = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: auto;
`;
export const SidebarPane = styled.div`
  flex: ${({ $expanded }) => ($expanded ? "0 0 21%" : "0 0 60px")};
  position: sticky;
  top: 0;
  z-index: 999;
  transition: flex 0.3s ease;
`;
export const ContentPane = styled.div`
  flex: ${({ $expanded }) => ($expanded ? "1 1 79%" : "1 1 calc(100% - 60px)")};
  transition: flex 0.3s ease;
  min-height: 100vh;
  overflow-y: auto;
`;
export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 999;
`;
export const MainWrapper = styled.div`
  width: ${({ $expanded }) => ($expanded ? "79vw" : "calc(100%)")};
`;
export const InnerWrapper = styled.div`
  width: 100%;
`;
export const HorizonSection = styled.div`
  margin-top: 36px;
  margin-bottom: 24px;
`;
export const PillContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
`;
export const PillButton = styled.button`
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  border: 1px solid ${({ $active }) => ($active ? BRAND : "#e2e8f0")};
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ $active }) => ($active ? BRAND : "#fff")};
  color: ${({ $active }) => ($active ? "#fff" : "#475569")};
  box-shadow: ${({ $active }) => ($active ? "0 2px 4px rgba(63, 136, 165, 0.15)" : "none")};
  &:hover {
    border-color: ${BRAND};
    color: ${({ $active }) => ($active ? "#fff" : BRAND)};
    background: ${({ $active }) => ($active ? BRAND : "#fafcff")};
  }
`;
export const DashboardPill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  ${({ $status }) =>
    $status === "ACHIEVED"
      ? "background:#e7f3ea;color:#3f8a5c;"
      : $status === "ON_TRACK"
        ? "background:#fff8e6;color:#a0651a;"
        : $status === "OFF_TRACK"
          ? "background:#fbeae8;color:#d0453c;"
          : "background:#f1f5f9;color:#94a3b8;"}
`;
export const DashboardTable = styled(Table)`
  th, td {
    padding: 10px 8px;
    white-space: nowrap;
    text-align: right;
  }
  th:first-child, td:first-child {
    text-align: left;
    white-space: normal;
    max-width: 260px;
  }
`;
